/**
 * Toast notification utility
 * Provides a showtoast function compatible with the one from application.js
 * Works without jQuery dependency
 */
export const showtoast = (message) => {
  // Use global showtoast if available (from application.js when jQuery is loaded)
  if (typeof window.showtoast === 'function') {
    window.showtoast(message);
    return;
  }

  // Fallback: create a simple toast notification without jQuery
  const toast = document.createElement('div');
  toast.className = 'toast';
  toast.textContent = message;
  toast.style.cssText = `
    position: fixed;
    top: 100px;
    right: 20px;
    background-color: #1f2937;
    color: white;
    padding: 12px 20px;
    border-radius: 6px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 10100;
    opacity: 0;
    transition: opacity 0.3s ease, right 0.3s ease;
    max-width: 300px;
    font-size: 14px;
  `;

  document.body.appendChild(toast);

  // Position toasts vertically (stack them)
  const existingToasts = document.querySelectorAll('.toast');
  let topOffset = 100;
  existingToasts.forEach((t) => {
    const height = t.offsetHeight;
    const offset = 10;
    t.style.top = `${topOffset}px`;
    topOffset += height + offset;
  });

  // Show toast with animation
  setTimeout(() => {
    toast.style.opacity = '1';
    toast.style.right = '20px';
  }, 10);

  // Hide and remove toast after 7 seconds
  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.right = '-400px';
    setTimeout(() => {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }
    }, 600);
  }, 7000);
};

// Export as default for convenience
export default showtoast;

